module.exports = __webpack_public_path__ + "261ed8b4f3d66892b3fea61ab9d94788.jpg";